import { render } from "./GuidesComponent.vue?vue&type=template&id=9958fdac&scoped=true"
import script from "./GuidesComponent.vue?vue&type=script&lang=js"
export * from "./GuidesComponent.vue?vue&type=script&lang=js"

import "./GuidesComponent.vue?vue&type=style&index=0&id=9958fdac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9958fdac"]])

export default __exports__